module.exports = __webpack_public_path__ + "static/about-background-6774108555fa05eb10771a4b161cd9f3.png";